import { Extension } from '@tiptap/core';

// Disables Ctrl+Enter / Cmd+Enter - prevent exit the current 'block' in some cases, used mainly for 'code' editor. (e.g. disables 'line break')
export const DisableCtrlEnter = Extension.create({
  addKeyboardShortcuts() {
    return {
      'Mod-Enter': () => true,
    };
  },
});
